import { Integration } from '@sentry/types';
import { IssueTracingOptions, getRAF, getContext } from '../metric-common';
import { addSpan, endSpan, endTransaction, startTransaction } from 'common-module/src/util/sentry/customer-transaction';

const FPS_MONITOR_TRACING_NAME = 'FpsMonitorTracing';

const DEFAULT_FPS_MONITOR_TRACING_OPTIONS = {
  reportIssueState: true
};

/**
 * FPS Monitor
 */
export class FPSMonitorTracing implements Integration {

  private _frame: number;
  private _lastTime: number;
  private _lastFameTime: number;
  /**
   * Raf 方法，接收一个callback方法，返回一个number值
   * @private
   */
  // eslint-disable-next-line no-unused-vars
  private readonly _rafFunc: (callback: any) => number;

  /**
   * @inheritDoc
   */
  public static id: string = FPS_MONITOR_TRACING_NAME;

  public options: FpsMonitorTracingOptions;

  /**
   * @inheritDoc
   */
  public name: string = FPSMonitorTracing.id;


  /**
   * @param _options
   */
  public constructor(_options?: Partial<FpsMonitorTracingOptions>) {
    this.options = {
      ...DEFAULT_FPS_MONITOR_TRACING_OPTIONS,
      ..._options
    };

    // init frame properties
    this._frame = 0;
    this._lastTime = Date.now();
    this._lastFameTime = Date.now();
    this._rafFunc = getRAF().bind(getContext());

    this.tracingFPS();
  }

  /**
   * 集成类通用启动方法，这里不需要启动，在构造函数中进行FPS监控的初始化即可
   */
  setupOnce(): void {
    // 这里需要考虑是否每个transaction都增加一下当前fps的统计，这个过程可能是有损的，需要测试一下是否会影响性能
  }

  /**
   * 监控FPS
   * TODO: fps可以连续收集连续fps较低时再做上报。单个fps低于30的话指标信息会较多
   */
  public tracingFPS(): void {

    const now = Date.now();
    const fs = (now - this._lastFameTime);
    let fps = Math.round(1000 / fs);

    this._lastFameTime = now;
    this._frame++;

    if (now > 1000 + this._lastTime) {
      fps = Math.round((this._frame * 1000) / (now - this._lastTime));
      if (fps <= 30) {
        const transaction = startTransaction(
          { name: 'fps-performance-transaction' },
          undefined,
          true,
          true
        );
        if (!transaction) {
          return;
        }
        const span = addSpan({
          op: 'app-fps',
          description: `fps 小于30会记录，当前fps: ${fps}`,
          tags: {
            'fps:currentFps': fps
          }
        });
        if (span) {
          endSpan(span);
        }
        endTransaction(transaction);
      }
      this._frame = 0;
      this._lastTime = now;
    }
    this._rafFunc(this.tracingFPS.bind(this));
  }
}


/**
 * Options for FpsMonitorTracingOptions integration
 */
export interface FpsMonitorTracingOptions extends IssueTracingOptions {
}
